﻿
import DefaultRenderer from './default';
import state from './../state';

class HTMLRenderer extends DefaultRenderer{

    constructor(){
        super();
        
    }

    setCanvas(element){
        super.setCanvas(element);
        this.renderOutput.result = element;
    }
    

    createNode(ctrl, blueprint){
        //super.createNode(ctrl, blueprint);

        let node = false;
        switch (ctrl.type){
            case 'rect':
                node = document.createElement('div');
                break;
            case 'group':
                node = document.createElement('div');
                break;
            case 'link':
                node = document.createElement('a');
                break;
            case 'textbox':
                node = document.createElement('span');
                break;
            case 'textinput':
                node = document.createElement('input');
                break;
            case 'textarea':
                node = document.createElement('textarea');
                break;
            case 'select':
                node = document.createElement('select');
                break;
            case 'option':
                node = document.createElement('option');
                break;
            case 'image':
                node = document.createElement('img');
                break;
            case 'table':
                node = document.createElement('table');
                break;
            case 'tablerow':
                node = document.createElement('tr');
                break;
            case 'tablecel':
                node = document.createElement('td');
                break;
            default:
                console.warn('Node type ' + ctrl.type + ' not suported by HTML renderer');
        }

        if(node !== false){
            this.attach(ctrl, node);
        }
    

    }

    attach(ctrl, node){
        let renderOutput = ctrl.renderOutput || {};        
        if(ctrl.parent && ctrl.parent.renderOutput && ctrl.parent.renderOutput.result){
            ctrl.parent.renderOutput.result.appendChild(node);
            renderOutput.result = node;
            ctrl.setRenderOutput(renderOutput);
            return true;
        }else{
            console.warn('Trying to add child to non existing parent');
            console.log(ctrl);
            renderOutput.result = false;
            ctrl.setRenderOutput(renderOutput);
            return false;
        }
    }

    detach(ctrl){
        super.detach(ctrl);
        if(ctrl.renderOutput.result.parentNode){    // only detach when the node is attached
            ctrl.parent.renderOutput.result.removeChild(ctrl.renderOutput.result);
        }
    }


    getEventBindingElement(ctrl){

        return ctrl.renderOutput.result;

    }

    setProperty(ctrl, keys, value, previous){
        value = super.setProperty(ctrl, keys, value, previous);
        let k = keys.slice(0);
        let name = k.splice(0,1)[0];

        if(name == 'position'){
            this.setPosition(ctrl, k, value);
        }else if(name == 'transform'){
            ctrl.setTransformation(k, value);
        }else if(name == 'style'){
            this.setStyle(ctrl, k, value);
        }else if(name == 'content'){
            ctrl.renderOutput.result.textContent = value || '';
        }else if(name == 'html'){
            if(value != previous){
                ctrl.renderOutput.result.innerHTML = value || '';
            }
        }else if(name == 'svg'){
            ctrl.renderOutput.result.textContent = value || '';
        }else if(name == 'attributes'){
            this.setAttribute(ctrl, k, value);
        }

    }

    getProperty(ctrl, keys){
        let k = keys.slice(0);
        let name = k.splice(0,1)[0];
        if(! ctrl || ! ctrl.renderOutput || !ctrl.renderOutput.result){
            return null;
        }


        if(name == 'position'){
            //this.getPosition(ctrl, k, value);
        }else if(name == 'transform'){
            //ctrl.getTransformation(k, value);
        }else if(name == 'style'){
            return this.getStyle(ctrl, k);
        }else if(name == 'content'){
            return ctrl.renderOutput.result.textContent || '';
        }else if(name == 'html'){
            return ctrl.renderOutput.result.innerHTML || '';
        }else if(name == 'svg'){
            return ctrl.renderOutput.result.textContent || '';
        }else if(name == 'attributes'){
            return this.getAttribute(ctrl, k);
        }

        return null;
    }

    setPosition(ctrl, keys, value){
        let name = keys.slice(0,1)[0];
        let pos = (typeof value == 'undefined' || undefined)? '': Math.round(value) + 'px';
        if(name == 'x'){
           ctrl.renderOutput.result.style.left = pos;
        }else if(name == 'y'){
            ctrl.renderOutput.result.style.top = pos;
        }
    }


    setStyle(ctrl, keys, value){
        let name = keys.slice(0,1)[0];
        if(name == 'float'){
            name = 'cssFloat';
        }
        if(typeof value == 'undefined' || value == null){
            if(ctrl.renderOutput.result.style[name] === undefined){
                return;
            }
            value = '';
        }
        ctrl.renderOutput.result.style[name] = value;
        
    }

    getStyle(ctrl, keys){
        let name = keys.slice(0,1)[0];
        if(name == 'float'){
            name = 'cssFloat';
        }
        if(ctrl.renderOutput.result.style[name] === undefined){
            return null;
        }
         
        return ctrl.renderOutput.result.style[name];
        
    }

    
    setAttribute(ctrl, keys, value){
        let name = keys.slice(0,1)[0];
        
        if(typeof value == 'undefined' || value == null){
            ctrl.renderOutput.result.removeAttribute(name);
        }else{
            if(name == 'value'){
                try{
                    ctrl.renderOutput.result.value = value;
                }catch(e){
                    // fail silently
                }
            }
            let p = name.split(':');
            if(p.length > 1){
                this.setAttributeNS(ctrl, p[0], p[1], value);
            }else{
                ctrl.renderOutput.result.setAttribute(name, value);
            }
        }
    }

    getAttribute(ctrl, keys){
        let name = keys.slice(0,1)[0];
        
        if(name == 'value'){
            try{
                return ctrl.renderOutput.result.value || null;
            }catch(e){
                return null;
            }
        }
        return ctrl.renderOutput.result.getAttribute(name);

    }

    setAttributeNS(ctrl, namespace, name, value){
        let ns = 'http://www.w3.org/2000/' + namespace; // just a guess
        if(namespace == 'svg'){
            ns = 'http://www.w3.org/2000/svg';
        }else if(namespace == 'xlink'){
            ns = 'http://www.w3.org/1999/xlink';
        }
        ctrl.renderOutput.result.setAttributeNS(ns, name, value);
    }

}

export default HTMLRenderer;